<template>
  <div>
    <v-layout row wrap justify-center class="mt-3 px-2">
      <v-flex
        class="editRules py-3 px-3"
        row
        xs12
        d-flex
        align-center
        justify-space-between
        elevation-2
      >
        <div class="d-flex">
          <h3 class="ms-2">
            <Icon
              icon="bellCogOutline"
              color="switchq lighten-1"
              iconClass="ms-2"
            />
            {{ content.header }}
          </h3>
        </div>
        <v-btn
          v-if="
            'sensors' in device.data &&
            Object.keys(device.data.sensors).length &&
            device.settings.sensor_type > 0
          "
          color="switchq lighten-1"
          text
          :disabled="
            (rules.length != 0 && rules[0].sensor == 'water') ||
            (rules.length != 0 && rules[0].sensor == 'hall') ||
            (rules.length != 0 && rules[0].sensor == 'isVibrating') ||
            disabledRules
          "
          @click="addRule"
        >
          <span v-show="$vuetify.breakpoint.smAndUp">
            {{ content.add }}
          </span>
          <Icon
            icon="Plus"
            color="switchq lighten-1"
            :iconClass="
              $vuetify.breakpoint.smAndUp ? 'ms-2' : 'addRuleBtn  ms-2'
            "
          />
        </v-btn>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="dialog"
      width="900"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      scrollable
      @click:outside="close"
    >
      <v-card class="rule-settings-card" color="grey lighten-4">
        <v-card-title>
          <span class="text-h5 text-center w-100 grey--text text--darken-2">
            {{ config ? content.select_edit : content.select_new }}
          </span>
        </v-card-title>

        <v-card-text class="rule-settings-card-text">
          <v-form @submit.prevent="submit" ref="form">
            <div class="notification-settings">
              <div
                id="notification-settings-card-1"
                class="notification-settings-card"
              >
                <div class="w-100 mb-3">
                  <h3 class="text-center">
                    {{ $t("notification-settings") }}
                  </h3>
                </div>
                <div class="setting-block">
                  <v-select
                    :item-disabled="config || editRuleSensor ? '' : 'disabled'"
                    v-model="form.sensor"
                    :items="sensors"
                    :label="$t('selectSens')"
                    :rules="[(v) => !!v || $t('mustSens')]"
                    required
                  ></v-select>
                  <v-select
                    v-show="
                      requiresThreshold &&
                      this.device.data.sensor_type != 7 &&
                      this.device.data.sensor_type != 21
                    "
                    :item-disabled="config || editRuleSensor ? '' : 'disabled'"
                    v-model="form.action"
                    :disabled="!form.sensor"
                    :items="availableActions"
                    :label="$t('selectThres')"
                    :rules="
                      !requiresThreshold ? [(v) => !!v || $t('mustAct')] : []
                    "
                    required
                  ></v-select>
                  <v-text-field
                    v-show="
                      requiresThreshold &&
                      this.device.data.sensor_type != 7 &&
                      this.device.data.sensor_type != 21
                    "
                    dir="ltr"
                    :disabled="!form.action"
                    v-model="form.value"
                    :label="$t('threshold')"
                    type="number"
                    :rules="
                      !requiresThreshold
                        ? [(v) => !isNaN(v) || $t('mustThres')]
                        : []
                    "
                    required
                  ></v-text-field>
                  <v-layout v-if="device.data.sensor_type == 11" row>
                    <v-flex d-flex align-center align-content-center>
                      <h4>{{ content.correctState }}:</h4>
                    </v-flex>
                    <v-flex>
                      <v-radio-group v-model="form.value" row>
                        <v-radio
                          class="radio"
                          color="primary"
                          :label="content.open"
                          :value="0"
                        ></v-radio>
                        <v-radio
                          class="radio"
                          color="primary"
                          :label="content.close"
                          :value="1"
                        ></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    v-if="
                      device.data.sensor_type == 12 ||
                      device.data.sensor_type == 13 ||
                      device.data.sensor_type == 14
                    "
                    row
                  >
                    <v-flex d-flex align-center align-content-center>
                      <h4>{{ content.correctState }}:</h4>
                    </v-flex>
                    <v-flex>
                      <v-radio-group v-model="form.value" row>
                        <v-radio
                          class="radio"
                          color="primary"
                          :label="content.open"
                          :value="0"
                        ></v-radio>
                        <v-radio
                          class="radio"
                          color="primary"
                          :label="content.close"
                          :value="1"
                        ></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    v-if="
                      /* device.data.sensor_type == 6 || */ device.data
                        .sensor_type == 7
                    "
                    row
                  >
                    <v-flex d-flex align-center align-content-center>
                      <h4>{{ content.correctState }}:</h4>
                    </v-flex>
                    <v-flex>
                      <v-radio-group v-model="form.value" row>
                        <v-radio
                          class="radio"
                          color="primary"
                          :label="content.lightOff"
                          :value="0"
                        ></v-radio>
                        <v-radio
                          class="radio"
                          color="primary"
                          :label="content.lightOn"
                          :value="1"
                        ></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    v-if="
                      /* device.data.sensor_type == 6 || */ device.settings
                        .sensor_type == 21
                    "
                    row
                  >
                    <v-flex d-flex align-center align-content-center>
                      <h4>{{ content.correctState }}:</h4>
                    </v-flex>
                    <v-flex>
                      <v-radio-group v-model="form.value" row>
                        <v-radio
                          class="radio"
                          color="primary"
                          :label="content.vibrateOff"
                          :value="0"
                        ></v-radio>
                        <v-radio
                          class="radio"
                          color="primary"
                          :label="content.vibrateOn"
                          :value="1"
                        ></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                </div>
              </div>
              <div
                id="notification-settings-card-2"
                class="notification-settings-card advancedOpts"
              >
                <div
                  class="notification-settings-card-title expandable-card mb-3"
                  @click="
                    showNotificationAdvancedSettings =
                      !showNotificationAdvancedSettings
                  "
                >
                  <span class="notification-settings-card-title-block"> </span>
                  <h3>
                    {{ $t("notification-settings-advanced") }}
                  </h3>
                  <span
                    class="notification-settings-card-title-block d-flex justify-end"
                  >
                    <v-icon v-if="$vuetify.breakpoint.smAndDown">
                      mdi-menu-{{
                        showNotificationAdvancedSettings ? "up" : "down"
                      }}
                    </v-icon>
                  </span>
                </div>
                <template
                  v-if="
                    $vuetify.breakpoint.mdAndUp ||
                    showNotificationAdvancedSettings
                  "
                >
                  <div class="setting-block mb-2 pb-4">
                    <v-row class="short-checkboxes">
                      <v-flex>
                        <v-checkbox
                          v-model="form.notifications.push"
                          :disabled="disabledNotifications.push ? true : false"
                          color="switchq lighten-1"
                          :label="$t('push')"
                          dense
                          hide-details
                          :true-value="1"
                          :false-value="0"
                        />
                      </v-flex>
                      <v-flex
                        v-show="
                          this.$store.getters['user/user']
                            .notification_privileges.whatsapp != '0'
                        "
                      >
                        <v-checkbox
                          v-model="form.notifications.whatsapp"
                          :disabled="
                            disabledNotifications.whatsapp ? true : false
                          "
                          color="switchq lighten-1"
                          :label="$t('whatsapp')"
                          dense
                          hide-details
                          :true-value="1"
                          :false-value="0"
                        />
                      </v-flex>
                      <v-flex>
                        <v-checkbox
                          v-model="form.notifications.email"
                          :disabled="disabledNotifications.email ? true : false"
                          color="red lighten-1"
                          :label="$t('emailNot')"
                          dense
                          hide-details
                          :true-value="1"
                          :false-value="0"
                        />
                      </v-flex>
                      <v-flex>
                        <v-checkbox
                          v-model="form.notifications.sms"
                          :disabled="disabledNotifications.sms ? true : false"
                          color="blue lighten-1"
                          :label="$t('smsNot')"
                          dense
                          hide-details
                          :true-value="1"
                          :false-value="0"
                        />
                      </v-flex>
                    </v-row>
                    <!-- <div class="d-flex row flex-nowrap justify-space-between"> -->
                    <!-- <div class="d-flex align-center">
                        <div :class="setLang() == 'en' ? 'switchLabel' : ''">
                          {{ $t("push") }}
                        </div>
                        <v-switch
                          :disabled="disabledNotifications.push ? true : false"
                          v-model="form.notifications.push"
                          :input-value="form.notifications.push"
                          inset
                          :false-value="0"
                          :true-value="1"
                          default
                          class="mx-2"
                          color="switchq lighten-2"
                        ></v-switch>
                      </div>
                      <div class="d-flex align-center">
                        <div :class="setLang() == 'en' ? 'switchLabel' : ''">
                          {{ $t("emailNot") }}
                        </div>
                        <v-switch
                          :disabled="disabledNotifications.email ? true : false"
                          v-model="form.notifications.email"
                          :input-value="form.notifications.email"
                          inset
                          :false-value="0"
                          :true-value="1"
                          color="switchq lighten-2"
                          class="mx-2"
                        ></v-switch>
                      </div>
                      <div class="d-flex align-center">
                        <div :class="setLang() == 'en' ? 'switchLabel' : ''">
                          {{ $t("smsNot") }}
                        </div>
                        <v-switch
                          :disabled="disabledNotifications.sms ? true : false"
                          :input-value="form.notifications.sms"
                          v-model="form.notifications.sms"
                          inset
                          :false-value="0"
                          :true-value="1"
                          color="switchq lighten-2"
                          class="mx-2"
                        ></v-switch>
                      </div> -->
                    <!-- </div> -->
                  </div>

                  <div class="setting-block d-flex flex-column align-center">
                    <h4>{{ $t("timeToErr") }}</h4>
                    <div class="repeats my-2" dir="rtl">
                      <v-btn
                        icon
                        color="blue"
                        @click="plusMinRepeat(form.repeats)"
                        @contextmenu.prevent="plusMinRepeat(form.repeats)"
                        @mousedown="changeRepeat(true)"
                        @touchstart="changeRepeat(true)"
                        @mouseleave="changeRepeat(true, false)"
                        @mouseup="changeRepeat(true, false)"
                        @touchend="changeRepeat(true, false)"
                        @touchcancel="changeRepeat(true, false)"
                      >
                        <Icon icon="Plus" />
                      </v-btn>
                      <v-layout column wrap align-center>
                        <v-flex
                          shrink
                          @click="editRepeats"
                          v-if="!editRepeatsTime"
                          class="pointer"
                          >{{ formRepeats }}</v-flex
                        >
                        <v-flex shrink v-else>
                          <time-fields
                            :value="formRepeats"
                            @save="saveRepFromDialog"
                            @close="editRepeatsTime = false"
                          />
                        </v-flex>
                        <v-flex shrink class="mt-n2">
                          <small>
                            {{ $t("minutes") }}
                          </small>
                        </v-flex>
                      </v-layout>
                      <v-btn
                        icon
                        color="red"
                        @click="minusMinRepeat(form.repeats)"
                        @contextmenu.prevent="minusMinRepeat(form.repeats)"
                        @mousedown="changeRepeat(false)"
                        @touchstart="changeRepeat(false)"
                        @mouseleave="changeRepeat(false, false)"
                        @mouseup="changeRepeat(false, false)"
                        @touchend="changeRepeat(false, false)"
                        @touchcancel="changeRepeat(false, false)"
                      >
                        <Icon icon="Minus" />
                      </v-btn>
                    </div>
                    <h4>{{ $t("timeToNormal") }}</h4>
                    <div class="counters my-2">
                      <v-btn
                        icon
                        color="blue"
                        @click="plusMinCounter(form.counter_repeats)"
                        @contextmenu.prevent="
                          plusMinCounter(form.counter_repeats)
                        "
                        @mousedown="changeCounter(true)"
                        @touchstart="changeCounter(true)"
                        @mouseleave="changeCounter(true, false)"
                        @mouseup="changeCounter(true, false)"
                        @touchend="changeCounter(true, false)"
                        @touchcancel="changeCounter(true, false)"
                      >
                        <Icon icon="Plus" />
                      </v-btn>
                      <v-layout column wrap align-center>
                        <v-flex
                          v-if="!editCounterRepeatsTime"
                          shrink
                          @click="editCounterRepeats"
                          class="pointer"
                        >
                          {{ formCounterRepeats }}
                        </v-flex>
                        <v-flex shrink v-else>
                          <time-fields
                            :value="formCounterRepeats"
                            @save="saveCounterRepFromDialog"
                            @close="editCounterRepeatsTime = false"
                          />
                        </v-flex>
                        <v-flex
                          v-show="!editCounterRepeatsTime"
                          shrink
                          class="mt-n2"
                        >
                          <small>
                            {{ $t("minutes") }}
                          </small>
                        </v-flex>
                      </v-layout>
                      <v-btn
                        icon
                        color="red"
                        @click="minusMinCounter(form.counter_repeats)"
                        @contextmenu.prevent="
                          minusMinCounter(form.counter_repeats)
                        "
                        @mousedown="changeCounter(false)"
                        @touchstart="changeCounter(false)"
                        @mouseleave="changeCounter(false, false)"
                        @mouseup="changeCounter(false, false)"
                        @touchend="changeCounter(false, false)"
                        @touchcancel="changeCounter(false, false)"
                      >
                        <Icon icon="Minus" />
                      </v-btn>
                    </div>
                  </div>
                </template>
              </div>
              <div
                v-if="
                  this.$userPermissions.permitted('scheduled-notifications')
                "
                id="notification-settings-card-3"
                class="notification-settings-card"
              >
                <div
                  class="notification-settings-card-title expandable-card"
                  @click="
                    showNotificationScheduleSettings =
                      !showNotificationScheduleSettings
                  "
                >
                  <small
                    v-if="form.repeat_settings && form.schedules.length"
                    class="notification-settings-card-title-block"
                  >
                    <v-badge color="blue" :content="form.schedules.length" />
                  </small>
                  <span v-else class="notification-settings-card-title-block">
                    <v-checkbox
                      v-model="useNotificationScheduleSettings"
                      hide-details
                    />
                  </span>
                  <h3
                    @click="useNotificationScheduleSettings = true"
                    :class="{ pointer: !useNotificationScheduleSettings }"
                  >
                    {{ $t("notification-settings-schedule") }}
                  </h3>
                  <span
                    class="notification-settings-card-title-block d-flex justify-end"
                  >
                    <v-icon
                      v-if="
                        $vuetify.breakpoint.smAndDown &&
                        useNotificationScheduleSettings
                      "
                    >
                      mdi-menu-{{
                        showNotificationScheduleSettings ? "up" : "down"
                      }}
                    </v-icon>
                  </span>
                </div>
                <template
                  v-if="
                    (useNotificationScheduleSettings &&
                      ($vuetify.breakpoint.mdAndUp ||
                        showNotificationScheduleSettings)) ||
                    form.schedules.length
                  "
                >
                  <small class="text-center">
                    {{ $t("notification-settings-schedule-explanation") }}
                  </small>
                  <v-layout
                    v-if="form.schedules.length"
                    class="w-100 shrink"
                    justify-center
                    column
                    align-center
                  >
                    <div
                      v-for="(schedule, i) in form.schedules"
                      :key="i"
                      :class="{
                        'setting-block schedule-block no-stretch mt-1': true,
                        'deep-purple lighten-5':
                          !!newScheduleSettings.slug &&
                          newScheduleSettings.slug == schedule.slug,
                      }"
                    >
                      <div class="d-flex">
                        <v-icon color="blue"> mdi-calendar-clock </v-icon>
                        <div class="d-flex flex-column ms-4">
                          <div class="text-wrap blue-grey--text text--darken-2">
                            {{
                              schedule.days.map((d) => getDayName(d)).join(", ")
                            }}
                          </div>
                          <div class="grey--text text--darken-1">
                            {{
                              $t("from-to", {
                                start: numToLargetime(schedule.start_at),
                                end: numToLargetime(schedule.end_at),
                              })
                            }}
                            <!-- {{ i == 0 ? editSchedule(i) : null }} -->
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="
                          !newScheduleSettings.slug ||
                          (newScheduleSettings.slug &&
                            newScheduleSettings.slug != schedule.slug)
                        "
                      >
                        <v-btn icon color="blue" @click="editSchedule(i)">
                          <v-icon size="19">mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn icon color="red" @click="removeSchedule(i)">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </v-layout>
                  <v-layout
                    v-else-if="!form.schedules.length && !showNewScheduleForm"
                    class="w-100 shrink"
                    justify-center
                    column
                    align-center
                  >
                    <div class="no-stretch mt-1">
                      <div class="d-flex">
                        <v-icon color="blue darken-4">
                          mdi-calendar-clock
                        </v-icon>
                        <div class="d-flex flex-column ms-4">
                          <div class="text-wrap blue--text text--darken-4">
                            {{ $t("notification-settings-schedule-24-7") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-layout>
                  <v-layout
                    ref="scheduleSettingForm"
                    v-if="showNewScheduleForm"
                    justify-center
                    column
                    align-center
                    class="setting-block mt-3"
                  >
                    <h4>
                      {{
                        $t(
                          "notification-schedule-form-" +
                            (newScheduleSettings.slug ? "edit" : "new")
                        )
                      }}
                    </h4>
                    <label>{{ $t("days") }}</label>
                    <v-row class="short-checkboxes mb-4" justify="space-around">
                      <v-col cols="3" class="pa-0">
                        <v-checkbox
                          v-model="newScheduleSettings.days"
                          :value="1"
                          dense
                          hide-details
                        >
                          <template slot="label">
                            <span>
                              {{ $t("fullWeekDays.sunday") }}
                            </span>
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col cols="3" class="pa-0">
                        <v-checkbox
                          v-model="newScheduleSettings.days"
                          :value="2"
                          dense
                          hide-details
                        >
                          <template slot="label">
                            <span>
                              {{ $t("fullWeekDays.monday") }}
                            </span>
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col cols="3" class="pa-0">
                        <v-checkbox
                          v-model="newScheduleSettings.days"
                          :value="3"
                          dense
                          hide-details
                        >
                          <template slot="label">
                            <span>
                              {{ $t("fullWeekDays.tuesday") }}
                            </span>
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col cols="3" class="pa-0">
                        <v-checkbox
                          v-model="newScheduleSettings.days"
                          :value="4"
                          dense
                          hide-details
                        >
                          <template slot="label">
                            <span>
                              {{ $t("fullWeekDays.wednesday") }}
                            </span>
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col cols="3" class="pa-0">
                        <v-checkbox
                          v-model="newScheduleSettings.days"
                          :value="5"
                          dense
                          hide-details
                        >
                          <template slot="label">
                            <span>
                              {{ $t("fullWeekDays.thursday") }}
                            </span>
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col cols="3" class="pa-0">
                        <v-checkbox
                          v-model="newScheduleSettings.days"
                          :value="6"
                          dense
                          hide-details
                        >
                          <template slot="label">
                            <span>
                              {{ $t("fullWeekDays.friday") }}
                            </span>
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col cols="3" class="pa-0">
                        <v-checkbox
                          v-model="newScheduleSettings.days"
                          :value="7"
                          dense
                          hide-details
                        >
                          <template slot="label">
                            <span>
                              {{ $t("fullWeekDays.saturday") }}
                            </span>
                          </template>
                        </v-checkbox>
                      </v-col>
                    </v-row>
                    <div class="counters my-2">
                      <v-btn
                        icon
                        color="blue"
                        @click="
                          plusScheduleStartAt(newScheduleSettings.start_at)
                        "
                        @contextmenu.prevent="
                          plusScheduleStartAt(newScheduleSettings.start_at)
                        "
                        @mousedown="changeScheduleStartAt(true)"
                        @touchstart="changeScheduleStartAt(true)"
                        @mouseleave="changeScheduleStartAt(true, false)"
                        @mouseup="changeScheduleStartAt(true, false)"
                        @touchend="changeScheduleStartAt(true, false)"
                        @touchcancel="changeScheduleStartAt(true, false)"
                      >
                        <Icon icon="Plus" />
                      </v-btn>
                      <v-layout column wrap align-center>
                        <v-flex
                          v-show="!editCounterRepeatsTime"
                          shrink
                          class="mt-n2"
                        >
                          <small>{{ $t("startTime") }}</small>
                        </v-flex>
                        <v-flex
                          shrink
                          @click="editCounterRepeats"
                          class="pointer"
                        >
                          <TimePickerMenu
                            v-model="newScheduleSettings.start_at"
                            :max="newScheduleSettings.end_at - 1"
                          >
                            <template #activator>
                              <span>
                                {{
                                  numToLargetime(newScheduleSettings.start_at)
                                }}
                              </span>
                            </template>
                          </TimePickerMenu>
                        </v-flex>
                      </v-layout>
                      <v-btn
                        icon
                        color="red"
                        @click="
                          minusScheduleStartAt(newScheduleSettings.start_at)
                        "
                        @contextmenu.prevent="
                          minusScheduleStartAt(newScheduleSettings.start_at)
                        "
                        @mousedown="changeScheduleStartAt(false)"
                        @touchstart="changeScheduleStartAt(false)"
                        @mouseleave="changeScheduleStartAt(false, false)"
                        @mouseup="changeScheduleStartAt(false, false)"
                        @touchend="changeScheduleStartAt(false, false)"
                        @touchcancel="changeScheduleStartAt(false, false)"
                      >
                        <Icon icon="Minus" />
                      </v-btn>
                    </div>
                    <div class="counters my-2">
                      <v-btn
                        icon
                        color="blue"
                        @click="plusScheduleEndAt(newScheduleSettings.end_at)"
                        @contextmenu.prevent="
                          plusScheduleEndAt(newScheduleSettings.end_at)
                        "
                        @mousedown="changeScheduleEndAt(true)"
                        @touchstart="changeScheduleEndAt(true)"
                        @mouseleave="changeScheduleEndAt(true, false)"
                        @mouseup="changeScheduleEndAt(true, false)"
                        @touchend="changeScheduleEndAt(true, false)"
                        @touchcancel="changeScheduleEndAt(true, false)"
                      >
                        <Icon icon="Plus" />
                      </v-btn>
                      <v-layout column wrap align-center>
                        <v-flex
                          v-show="!editCounterRepeatsTime"
                          shrink
                          class="mt-n2"
                        >
                          <small>{{ $t("endTime") }}</small>
                        </v-flex>
                        <v-flex
                          shrink
                          @click="editCounterRepeats"
                          class="pointer"
                        >
                          <TimePickerMenu
                            v-model="newScheduleSettings.end_at"
                            :min="newScheduleSettings.start_at + 1"
                          >
                            <template #activator>
                              <span>
                                {{ numToLargetime(newScheduleSettings.end_at) }}
                              </span>
                            </template>
                          </TimePickerMenu>
                        </v-flex>
                      </v-layout>
                      <!--  -->
                      <v-btn
                        icon
                        color="red"
                        @click="minusScheduleEndAt(newScheduleSettings.end_at)"
                        @contextmenu.prevent="
                          minusScheduleEndAt(newScheduleSettings.end_at)
                        "
                        @mousedown="changeScheduleEndAt(false)"
                        @touchstart="changeScheduleEndAt(false)"
                        @mouseleave="changeScheduleEndAt(false, false)"
                        @mouseup="changeScheduleEndAt(false, false)"
                        @touchend="changeScheduleEndAt(false, false)"
                        @touchcancel="changeScheduleEndAt(false, false)"
                      >
                        <Icon icon="Minus" />
                      </v-btn>
                    </div>
                    <v-row class="d-flex w-100">
                      <v-btn
                        text
                        color="success"
                        @click="SaveScheduleSettings"
                        :disabled="
                          Object.values(newRepeatSettings.channels).filter(
                            (c) => c
                          ).length === 0
                        "
                      >
                        {{ newScheduleSettings.slug ? $t("save") : $t("add") }}
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn text color="grey" @click="closeNewScheduleForm">
                        {{ $t("cancel") }}
                      </v-btn>
                    </v-row>
                  </v-layout>
                  <v-layout v-else-if="!showNewScheduleForm" justify-center>
                    <v-btn
                      color="blue darken-4"
                      class="ma-2 white--text"
                      plain
                      block
                      @click="showNewScheduleForm = true"
                    >
                      {{
                        $t(
                          "notification-schedule-form-" +
                            (newScheduleSettings.slug ? "edit" : "new")
                        )
                      }}
                      <v-icon right dark> mdi-plus </v-icon>
                    </v-btn>
                  </v-layout>
                </template>
              </div>
              <div
                v-if="this.$userPermissions.permitted('repeated-alerts')"
                id="notification-settings-card-4"
                class="notification-settings-card advancedOpts"
              >
                <div
                  class="notification-settings-card-title expandable-card"
                  @click="
                    showNotificationRepeatsSettings =
                      !showNotificationRepeatsSettings
                  "
                >
                  <small
                    v-if="form.repeat_settings && currentRepeatSettings.length"
                    class="notification-settings-card-title-block"
                  >
                    <v-badge
                      color="blue"
                      :content="currentRepeatSettings.length"
                    />
                  </small>
                  <span v-else class="notification-settings-card-title-block">
                    <v-checkbox
                      v-model="useNotificationRepeatsSettings"
                      hide-details
                    />
                  </span>
                  <h3
                    @click="useNotificationRepeatsSettings = true"
                    :class="{ pointer: !useNotificationRepeatsSettings }"
                  >
                    {{ $t("notification-settings-repeats") }}
                  </h3>
                  <span
                    class="notification-settings-card-title-block d-flex justify-end"
                  >
                    <v-icon
                      v-if="
                        $vuetify.breakpoint.smAndDown &&
                        useNotificationRepeatsSettings
                      "
                    >
                      mdi-menu-{{
                        showNotificationRepeatsSettings ? "up" : "down"
                      }}
                    </v-icon>
                  </span>
                </div>
                <template
                  v-if="
                    (useNotificationRepeatsSettings &&
                      ($vuetify.breakpoint.mdAndUp ||
                        showNotificationRepeatsSettings)) ||
                    currentRepeatSettings.length
                  "
                >
                  <v-row class="mt-2 shrink" justify="center">
                    <v-btn-toggle
                      v-model="form.repeat_settings_type"
                      rounded
                      background-color="grey lighten-2"
                      color="switchq"
                      mandatory
                      dense
                      class="pop-design"
                    >
                      <v-btn :value="1">
                        {{ $t("notification-settings-repeats-recurring") }}
                      </v-btn>
                      <v-btn :value="0">
                        {{ $t("notification-settings-repeats-customized") }}
                      </v-btn>
                    </v-btn-toggle>
                  </v-row>
                  <small class="text-center">
                    {{ $t("notification-settings-repeats-explanation") }}
                  </small>
                  <v-layout
                    v-if="currentRepeatSettings.length"
                    class="w-100 shrink"
                    justify-center
                    column
                    align-center
                  >
                    <div
                      v-for="(repeat, i) in currentRepeatSettings"
                      :key="i"
                      class="setting-block no-stretch mt-1"
                    >
                      <div class="d-flex align-center">
                        <div class="d-flex flex-column me-3">
                          <v-icon color="red"> mdi-bell-ring </v-icon>
                        </div>
                        <div class="d-flex flex-column">
                          <div class="">
                            <span>
                              {{
                                form.repeat_settings_type === 1
                                  ? $t("Every")
                                  : $t("After")
                              }}
                            </span>
                            {{ repeat.repeat_after }} {{ $t("minutes") }}
                          </div>
                          <div>
                            {{
                              Object.entries(repeat.channels)
                                .filter((c) => c[1])
                                .map((c) => {
                                  switch (c[0]) {
                                    case "push":
                                      return $t("push");
                                    case "sms":
                                      return $t("smsNot");
                                    case "email":
                                      return $t("emailNot");
                                    case "whatsapp":
                                      return $t("whatsapp");
                                  }
                                })
                                .join(", ")
                            }}
                          </div>
                        </div>
                      </div>
                      <div>
                        <v-btn icon color="red" @click="removeRepeat(i)">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </v-layout>
                  <v-layout
                    v-if="showNewRepeatForm"
                    class="setting-block mt-3"
                    justify-center
                    column
                    align-center
                  >
                    <h4>
                      {{
                        form.repeat_settings_type === 1
                          ? $t("notification-recurring-button")
                          : $t("notification-custom-repeat-button")
                      }}
                    </h4>
                    <small class="very-small">
                      {{
                        form.repeat_settings_type === 1
                          ? $t(
                              "notification-settings-recurring-minutes-explanation"
                            )
                          : $t(
                              "notification-settings-custom-repeats-minutes-explanation"
                            )
                      }}
                    </small>
                    <v-row class="repeats mb-2" dir="rtl">
                      <v-btn
                        icon
                        color="blue"
                        @click="
                          plusRepeatSettings(newRepeatSettings.repeat_after)
                        "
                        @contextmenu.prevent="
                          plusRepeatSettings(newRepeatSettings.repeat_after)
                        "
                        @mousedown="changeRepeatSettings(true)"
                        @touchstart="changeRepeatSettings(true)"
                        @mouseleave="changeRepeatSettings(true, false)"
                        @mouseup="changeRepeatSettings(true, false)"
                        @touchend="changeRepeatSettings(true, false)"
                        @touchcancel="changeRepeatSettings(true, false)"
                      >
                        <Icon size="30" icon="Plus" />
                      </v-btn>
                      <v-layout
                        class="repeat-inner-text"
                        row
                        wrap
                        align-center
                        justify-center
                        :style="{
                          flexDirection: !$vuetify.rtl ? 'row-reverse' : 'row',
                        }"
                      >
                        <small shrink class="text-end">
                          {{
                            form.repeat_settings_type === 1
                              ? $t("every")
                              : $t("after")
                          }}
                        </small>
                        <v-flex shrink class="mx-1">
                          {{ newRepeatSettings.repeat_after }}
                        </v-flex>
                        <small shrink class="text-start">
                          {{ $t("minutes") }}
                        </small>
                      </v-layout>
                      <v-btn
                        icon
                        color="red"
                        @click="
                          minusRepeatSettings(newRepeatSettings.repeat_after)
                        "
                        @contextmenu.prevent="
                          minusRepeatSettings(newRepeatSettings.repeat_after)
                        "
                        @mousedown="changeRepeatSettings(false)"
                        @touchstart="changeRepeatSettings(false)"
                        @mouseleave="changeRepeatSettings(false, false)"
                        @mouseup="changeRepeatSettings(false, false)"
                        @touchend="changeRepeatSettings(false, false)"
                        @touchcancel="changeRepeatSettings(false, false)"
                      >
                        <Icon size="30" icon="Minus" />
                      </v-btn>
                    </v-row>
                    <span v-if="form.repeat_settings_type === 1" class="">
                      <v-alert
                        v-if="newRepeatSettings.repeat_after < 5"
                        color="deep-orange"
                        outlined
                        text
                        dense
                      >
                        <div class="d-flex flex-column text-center">
                          <small v-if="newRepeatSettings.repeat_after < 5">
                            {{
                              $t(
                                "notification-settings-recurring-limit-explanation-1"
                              )
                            }}
                          </small>
                        </div>
                      </v-alert>
                      <div class="d-flex flex-column text-center">
                        <small>
                          {{
                            $t(
                              "notification-settings-recurring-limit-explanation-2"
                            )
                          }}
                        </small>
                      </div>
                    </span>
                    <v-row class="short-checkboxes">
                      <v-flex>
                        <v-checkbox
                          v-model="newRepeatSettings.channels.push"
                          :color="
                            !disabledNotifications.push
                              ? 'switchq lighten-1'
                              : 'grey lighten-2'
                          "
                          dense
                          hide-details
                        >
                          <template slot="label">
                            <span
                              :class="
                                !!disabledNotifications.push
                                  ? 'grey--text text--lighten-1'
                                  : 'switchq--text text--lighten-1'
                              "
                            >
                              {{ $t("push") }}
                            </span>
                          </template>
                        </v-checkbox>
                      </v-flex>
                      <v-flex>
                        <!-- :disabled="disabledNotifications.sms ? true : false" -->
                        <v-checkbox
                          v-model="newRepeatSettings.channels.email"
                          :color="
                            !disabledNotifications.sms
                              ? 'red lighten-1'
                              : 'grey lighten-2'
                          "
                          dense
                          hide-details
                        >
                          <template slot="label">
                            <span
                              :class="
                                !!disabledNotifications.sms
                                  ? 'grey--text text--lighten-1'
                                  : 'red--text text--lighten-1'
                              "
                            >
                              {{ $t("emailNot") }}
                            </span>
                          </template>
                        </v-checkbox>
                      </v-flex>
                      <v-flex>
                        <!-- :disabled="disabledNotifications.email ? true : false" -->
                        <v-checkbox
                          v-model="newRepeatSettings.channels.sms"
                          :color="
                            !disabledNotifications.email
                              ? 'blue lighten-1'
                              : 'grey lighten-2'
                          "
                          dense
                          hide-details
                        >
                          <template slot="label">
                            <span
                              :class="
                                !!disabledNotifications.email
                                  ? 'grey--text text--lighten-1'
                                  : 'blue--text text--lighten-1'
                              "
                            >
                              {{ $t("smsNot") }}
                            </span>
                          </template>
                        </v-checkbox>
                      </v-flex>
                      <v-flex
                        v-show="
                          this.$store.getters['user/user']
                            .notification_privileges.whatsapp != '0'
                        "
                      >
                        <!-- :disabled="disabledNotifications.email ? true : false" -->
                        <v-checkbox
                          v-model="newRepeatSettings.channels.whatsapp"
                          :color="
                            !disabledNotifications.whatsapp
                              ? 'green lighten-1'
                              : 'grey lighten-2'
                          "
                          dense
                          hide-details
                        >
                          <template slot="label">
                            <span
                              :class="
                                !!disabledNotifications.whatsapp
                                  ? 'grey--text text--lighten-1'
                                  : 'green--text text--lighten-1'
                              "
                            >
                              {{ $t("whatsapp") }}
                            </span>
                          </template>
                        </v-checkbox>
                      </v-flex>
                    </v-row>
                    <v-row class="d-flex w-100">
                      <v-btn
                        text
                        color="success"
                        @click="addNewRepeatSettings"
                        :disabled="
                          Object.values(newRepeatSettings.channels).filter(
                            (c) => c
                          ).length === 0
                        "
                      >
                        {{ $t("add") }}
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="grey"
                        @click="showNewRepeatForm = false"
                      >
                        {{ $t("cancel") }}
                      </v-btn>
                    </v-row>
                  </v-layout>
                  <v-layout
                    v-else-if="
                      !showNewRepeatForm &&
                      (form.repeat_settings_type
                        ? !form.repeat_settings.filter((r) => r.recurring)
                            .length
                        : true)
                    "
                    justify-center
                  >
                    <v-btn
                      color="blue darken-4"
                      class="ma-2 white--text"
                      plain
                      block
                      @click="showNewRepeatSettings"
                    >
                      {{
                        form.repeat_settings_type === 1
                          ? $t("notification-recurring-button")
                          : $t("notification-custom-repeat-button")
                      }}
                      <v-icon right dark> mdi-plus </v-icon>
                    </v-btn>
                  </v-layout>
                </template>
              </div>
            </div>
          </v-form>
        </v-card-text>

        <v-divider light v-if="!$vuetify.breakpoint.smAndDown"></v-divider>

        <v-card-actions class="cardActions">
          <v-spacer></v-spacer>
          <v-flex row xs12 justify-space-between>
            <v-btn
              color="primary"
              text
              @click="!config ? submit() : submitEdit()"
            >
              {{ $t("confirm") }}
            </v-btn>
            <v-btn
              v-show="formHasChanges"
              color="orange darken-2"
              size="small"
              text
              @click="undoChanges()"
            >
              {{ $t("undo-changes") }}
            </v-btn>
            <v-btn color="grey" text @click="close()">
              {{ $t("cancel") }}
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout row wrap justify-center>
      <v-flex xs10>
        <v-layout column v-if="Object.values(device.rules).length">
          <v-flex
            grow
            v-for="(rule, index) in rules"
            :key="index"
            class="rule mt-2'"
            elevation-1
          >
            <!-- exceeds && -->
            <v-layout
              row
              nowrap
              align-center
              :class="
                rule.value == exceeds &&
                (rule.sensor == device.exceedsRule ||
                  (device.exceedsRule &&
                    device.exceedsRule.includes(rule.sensor)))
                  ? 'ruleExceeds black--text px-3 py-2'
                  : 'black--text px-3 py-2'
              "
            >
              <v-flex xs10 md8>
                <v-layout column>
                  <v-flex>
                    <span class="me-4 text-subtitle-2">
                      {{ $t("sensor") }}:
                    </span>
                    <span class="text-xs-subtitle-1 text-md-h6">
                      {{ $t(rule.sensor) }}
                    </span>
                  </v-flex>
                  <v-divider light v-if="rule.sensor != 'water'"></v-divider>
                  <v-flex v-if="rule.sensor != 'water'">
                    <v-layout row wrap align-baseline>
                      <v-flex shrink>
                        <!-- device.data.sensor_type != 6 && -->
                        <span class="me-4 text-subtitle-2">
                          {{
                            rule.sensor != "hall" &&
                            device.data.sensor_type != 7 &&
                            rule.sensor != "isVibrating" &&
                            rule.sensor != "drycontact" &&
                            rule.sensor != "detection"
                              ? $t(rule.action_text)
                              : content.correctState
                          }}:
                        </span>
                      </v-flex>
                      <v-flex row v-if="rule.sensor != 'water'">
                        <!-- device.data.sensor_type != 6 && -->
                        <span
                          v-if="
                            editRuleSensor == rule.id &&
                            !config &&
                            rule.sensor != 'hall' &&
                            device.data.sensor_type != 7 &&
                            rule.sensor != 'isVibrating' &&
                            rule.sensor != 'drycontact'
                          "
                        >
                          <v-text-field
                            v-model="form.value"
                            class="input-group--focused"
                            single-line
                            type="number"
                            autofocus
                            dense
                            hide-details
                            @keypress.enter="submitEdit"
                          ></v-text-field>
                        </span>
                        <span v-else>
                          <!-- device.data.sensor_type == 6 || -->
                          <span
                            v-if="device.data.sensor_type == 7"
                            @click="rule.sensor != 'hall' ? editRule(rule) : ''"
                            class="text-xs-subtitle-1 text-md-h6"
                            dir="ltr"
                          >
                            {{
                              rule.value == 1 || rule.value == true
                                ? content.lightOn
                                : content.lightOff
                            }}{{ sensorsTitles[rule.sensor] }}
                          </span>
                          <span
                            v-else-if="device.settings.sensor_type == 21"
                            @click="editRule(rule)"
                            class="text-xs-subtitle-1 text-md-h6"
                            dir="ltr"
                          >
                            {{
                              rule.value == 1 || rule.value == true
                                ? content.vibrateOn
                                : content.vibrateOff
                            }}{{ sensorsTitles[rule.sensor] }}
                          </span>
                          <span
                            v-else
                            @click="
                              rule.sensor != 'hall' &&
                              rule.sensor != 'drycontact' &&
                              rule.sensor != 'water' &&
                              rule.sensor != 'detection'
                                ? editRule(rule)
                                : ''
                            "
                            class="text-xs-subtitle-1 text-md-h6"
                            dir="ltr"
                          >
                            {{
                              rule.sensor != "hall" &&
                              rule.sensor != "drycontact"
                                ? rule.value
                                : rule.value == 0
                                ? content.open
                                : content.close
                            }}{{ sensorsTitles[rule.sensor] }}
                          </span>
                        </span>
                        <v-spacer></v-spacer>
                        <!-- device.data.sensor_type != 6 && -->
                        <v-btn
                          v-if="
                            editRuleSensor != rule.id &&
                            rule.sensor != 'hall' &&
                            device.data.sensor_type != 7 &&
                            rule.sensor != 'isVibrating' &&
                            rule.sensor != 'drycontact'
                          "
                          @click="editRule(rule)"
                          text
                          icon
                          color="switchq lighten-1"
                        >
                          <Icon icon="edit" />
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs2 md4>
                <v-layout row wrap justify-end>
                  <v-btn
                    v-if="editRuleSensor != rule.id"
                    @click="configRule(rule)"
                    text
                    icon
                    color="grey darken-2"
                  >
                    <Icon icon="settingsIcon" />
                  </v-btn>
                  <v-btn
                    v-if="editRuleSensor == rule.id && !config"
                    @click="submitEdit()"
                    text
                    icon
                    color="green"
                  >
                    <Icon icon="checkIcon" />
                  </v-btn>
                  <v-btn
                    v-if="editRuleSensor != rule.id && !config"
                    @click="deleteRule(rule)"
                    text
                    icon
                    color="red"
                  >
                    <Icon icon="deleteIcon" />
                  </v-btn>
                  <v-btn
                    v-if="editRuleSensor == rule.id && !config"
                    @click="close()"
                    text
                    icon
                    color="grey darken-1"
                  >
                    <Icon icon="mdiClose" />
                  </v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center>
      <v-flex xs10>
        <v-layout column mt-0>
          <template>
            <v-row justify="center">
              <v-expansion-panels
                class="rule disconnectRule"
                accordion
                v-model="openAccordion"
                light
              >
                <v-expansion-panel>
                  <v-expansion-panel-header disable-icon-rotate>
                    <v-layout column wrap align-center>
                      <div class="disconnectLabel">
                        {{ $t("to-disconnect") }}
                      </div>
                      <div>{{ disconnectTime }}</div>
                    </v-layout>
                    <template v-slot:actions>
                      <Icon icon="edit" color="switchq lighten-1" />
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content
                    ref="disconnectAccordion"
                    dir="rtl"
                  >
                    <v-flex grow class="rule" elevation-1 mb-6>
                      <v-layout row nowrap align-center black--text px-3 py-2>
                        <v-btn
                          @click="plusMinDisconnect(timeToDisconnect)"
                          @contextmenu.prevent="
                            plusMinDisconnect(timeToDisconnect)
                          "
                          @mousedown="changeDisconnect(true)"
                          @touchstart="changeDisconnect(true)"
                          @mouseleave="changeDisconnect(true, false)"
                          @mouseup="changeDisconnect(true, false)"
                          @touchend="changeDisconnect(true, false)"
                          @touchcancel="changeDisconnect(true, false)"
                        >
                          <Icon icon="Plus" /> </v-btn
                        ><v-layout column wrap align-center>
                          <v-flex
                            shrink
                            @dblclick="editDisconnect"
                            v-if="!editDisconnectTime"
                            class="pointer"
                          >
                            {{ disconnectTime }}
                          </v-flex>
                          <v-flex shrink v-else>
                            <v-text-field
                              :autofocus="true"
                              :label="$t('minutes')"
                              class="disconnectTime"
                              type="number"
                              v-model="timeToDisconnect"
                              @keypress.enter="disconnectChange"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-btn
                          @click="minusMinDisconnect(timeToDisconnect)"
                          @contextmenu.prevent="
                            minusMinDisconnect(timeToDisconnect)
                          "
                          @mousedown="changeDisconnect(false)"
                          @touchstart="changeDisconnect(false)"
                          @mouseleave="changeDisconnect(false, false)"
                          @mouseup="changeDisconnect(false, false)"
                          @touchend="changeDisconnect(false, false)"
                          @touchcancel="changeDisconnect(false, false)"
                        >
                          <Icon icon="Minus" />
                        </v-btn>
                      </v-layout>
                    </v-flex>
                    <v-btn color="primary" @click="disconnectChange" block>{{
                      $t("confirm")
                    }}</v-btn>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>
          </template>
        </v-layout>
      </v-flex>
    </v-layout>
    <Modal
      :activator="!!deleteRuleSensor"
      @close="deleteRuleSensor = null"
      @delete="deleteRule()"
    />
  </div>
</template>
<script>
import Lang from "@/helpers/lang";
import axios from "@/plugins/axios";
import Modal from "@/components/general/DeleteModal.vue";
import TimeFields from "@/components/general/TimeFields.vue";
import TimePickerMenu from "@/components/tools/timePickerMenu.vue";

export default {
  name: "notificationRules",
  components: {
    Modal,
    TimeFields,
    TimePickerMenu,
  },
  data() {
    return {
      touching: null,
      config: false,
      dialog: false,
      deleteRuleSensor: null,
      editRuleSensor: null,
      editRepeatsTime: false,
      editCounterRepeatsTime: false,
      editDisconnectTime: false,
      timeToDisconnect: null,
      showNotificationAdvancedSettings: false,
      //  Schedule settings
      useNotificationScheduleSettings: false,
      showNotificationScheduleSettings: false,
      showNewScheduleForm: false,
      //  Repeats settings
      useNotificationRepeatsSettings: false,
      showNotificationRepeatsSettings: false,
      showNewRepeatForm: false,
      openAccordion: [],
      form: {
        sensor: null,
        action: null,
        value: null,
        repeats: 0,
        counter_repeats: 0,
        notifications: {
          push: 1,
          email: 1,
          sms: 1,
          whatsapp: 1,
          text: "",
          counter_text: "",
        },
        schedules: [
          // {
          //   days: [3, 4],
          //   start_at: 0,
          //   end_at: 1439,
          // },
          // {
          //   days: [1, 2, 6, 7],
          //   start_at: 290,
          //   end_at: 600,
          // },
        ],
        repeat_settings_type: 1,
        repeat_settings: [],
      },
      formClone: "",
      newRepeatSettings: {
        repeat_after: 5,
        channels: {
          push: 1,
          email: 1,
          sms: 1,
        },
        recurring: 1,
      },
      newScheduleSettings: {
        days: [1, 2, 3, 4, 5, 6, 7],
        start_at: 0,
        end_at: 1439,
      },
      customMsg: {
        forText: null,
        forCounterText: null,
      },
      sensorsTitles: {
        range: "cm",
        temperature: "°C",
        humidity: "%",
        co2: "ppm",
        pressure: "hPa",
      },
    };
  },
  computed: {
    disabledRules() {
      let device = JSON.parse(JSON.stringify(this.device));
      let disabled = false;
      if (
        Object.keys(device.data.sensors).includes("temperature") &&
        !Object.keys(device.data.sensors).includes("humidity") &&
        this.rules.length == 2
      ) {
        disabled = true;
      } else if (
        !Object.keys(device.data.sensors).includes("temperature") &&
        Object.keys(device.data.sensors).includes("humidity") &&
        this.rules.length == 2
      ) {
        disabled = true;
      } else if (
        Object.keys(device.data.sensors).includes("temperature") &&
        Object.keys(device.data.sensors).includes("humidity") &&
        !Object.keys(device.data.sensors).includes("co2") &&
        !Object.keys(device.data.sensors).includes("pressure") &&
        this.rules.length == 4
      ) {
        disabled = true;
      } else if (
        Object.keys(device.data.sensors).includes("temperatures") &&
        Object.keys(device.data.sensors).includes("humidity") &&
        Object.keys(device.data.sensors).includes("co2") &&
        Object.keys(device.data.sensors).includes("pressure") &&
        this.rules.length == 8
      ) {
        disabled = true;
      } else {
        disabled = false;
      }
      return disabled;
    },
    disabledNotifications() {
      let disabled = {};
      let userNotes = this.$store.getters["user/notifications"];
      if (userNotes.email == 0) {
        disabled.email = true;
      }
      if (userNotes.whatsapp == 0) {
        disabled.whatsapp = true;
      }
      if (userNotes.sms == 0) {
        disabled.sms = true;
      }
      let pushNotes = this.settings.push;
      if (pushNotes == 0) {
        disabled.push = true;
      }
      return disabled;
    },
    settings() {
      return this.$store.getters["devices/device"](this.$route.params.slug)
        .settings;
    },
    notifications() {
      let ruleNotes = this.$store.getters["devices/device"](
        this.$route.params.slug
      ).rules;
      let notes;
      for (let i = 0; i < ruleNotes.length; i++) {
        if ("notifications" in ruleNotes[i]) {
          notes = { ...ruleNotes[i].notifications };
        } else {
          notes = {};
        }
      }
      return notes;
    },
    cycle() {
      if (this.settings && this.settings.cycle) {
        let roundCycle = this.$store.getters["devices/device"](
          this.$route.params.slug
        ).settings.cycle;
        return parseFloat(((Math.ceil(roundCycle / 10) * 10) / 60).toFixed(2));
      } else {
        return null;
      }
    },
    device() {
      let device = this.$store.getters["devices/device"](
        this.$route.params.slug
      );
      return device;
    },
    exceeds() {
      return this.device.exceeds ? this.device.exceedsVal : false;
    },
    sensors() {
      const sensorsNames = {
        temperature: this.$t("temperature"),
        hall: this.$t("hall"),
        water: this.$t("water"),
        drycontact: this.$t("drycontact"),
        humidity: this.$t("humidity"),
        light: this.$t("light"),
        co2: this.$t("co2"),
        pressure: this.$t("pressure"),
        range: this.$t("range"),
        isVibrating: this.$t("isVibrating"),
      };
      if (
        this.device &&
        this.device.data &&
        "sensors" in this.device.data &&
        Object.keys(this.device.data.sensors).length
      ) {
        // delete this.device.data.sensors.temperatures;
        return Object.keys(this.device.data.sensors)
          .map((s) => {
            if (s === "temperatures") s = "temperature";
            return {
              value: s,
              text: sensorsNames[s],
              disabled:
                this.rules.filter((r) => {
                  const sensor =
                    r.sensor == "temperature" ? "temperature" : r.sensor;
                  return sensor == s;
                }).length == this.actions.length,
            };
          })
          .filter((s) => s.text);
      } else {
        return {};
      }
    },
    actions() {
      return [
        {
          value: ">",
          text: this.$t("top_threshold"),
        },
        {
          value: "<",
          text: this.$t("bottom_threshold"),
        },
      ];
    },
    availableActions() {
      const sensorExistingRules = this.rules
        .filter((r) => r.sensor === this.form.sensor)
        .map((r) => r.action);
      let actions = [...this.actions].map((action) => {
        action.disabled = sensorExistingRules.includes(action.value);
        return action;
      });
      return actions;
    },

    rules() {
      return { ...this.device }.rules.map((r) => {
        r.sensor = r.sensor == "temperatures" ? "temperature" : r.sensor;
        r.action_text = this.actions.find((a) => a.value == r.action).text;
        return r;
      });
    },
    formCounterRepeats() {
      return this.numToTime(this.form.counter_repeats);
    },
    formRepeats() {
      return this.numToTime(this.form.repeats);
    },
    minNewRepeatTime() {
      const lastRepeat = this.form.repeat_settings.length
        ? this.form.repeat_settings.slice(-1)[0]
        : null;
      const minTime = (lastRepeat ? lastRepeat.repeat_after : 0) + 1;
      return minTime;
    },
    ttl() {
      return this.device.offline_notification.ttl;
    },
    disconnectTime() {
      const ttl = this.timeToDisconnect ?? this.ttl;
      const minutes = String(ttl % 60).padStart(2, 0);
      const hours = String((ttl - minutes) / 60).padStart(2, 0);
      return [hours, minutes, "00"].join(":");
    },
    notificationsDefaultTime() {
      let wantedTime = 20;
      const cycle = this.cycle || 0.1;
      let defaultTime = cycle;
      while (defaultTime < wantedTime) {
        defaultTime = defaultTime + cycle;
      }
      defaultTime = parseFloat(defaultTime.toFixed(2));
      return defaultTime;
    },
    requiresThreshold() {
      const sensors = [
        "temperature",
        "humidity",
        "light",
        "co2",
        "pressure",
        "range",
      ];
      return sensors.includes(this.form.sensor);
    },
    currentRepeatSettings() {
      return this.form.repeat_settings.filter(
        (c) => c.recurring === this.form.repeat_settings_type
      );
    },
    formHasChanges() {
      return this.formClone
        ? this.formClone !== JSON.stringify(this.form)
          ? true
          : false
        : false;
    },
  },
  watch: {
    dialog() {
      this.showNotificationAdvancedSettings = false;
      this.showNotificationRepeatsSettings = false;
      this.form.repeat_settings_type = 1;
      if (this.form.repeat_settings.length) {
        this.form.repeat_settings_type = this.form.repeat_settings[0].recurring;
      }
    },
    ttl(ttl) {
      this.timeToDisconnect = ttl;
    },
    openAccordion() {
      if (this.openAccordion == []) {
        this.editDisconnectTime = false;
      }
    },
    showNotificationRepeatsSettings(newValue) {
      if (!newValue) this.showNewRepeatForm = false;
    },
    "form.value"(value) {
      if (this.form.sensor == "hall" || this.form.sensor == "drycontact") {
        if (value == 1 || value == "1.00") {
          this.form.action = "<";
        } else {
          this.form.action = ">";
        }
      }
      if (this.form.sensor == "isVibrating") {
        // console.log("value is", value);
        if (value == 1) this.form.action = "<";
        else this.form.action = ">";
      }
      if (
        // this.device.data.sensor_type == 6 ||
        this.device.data.sensor_type == 7
      ) {
        // console.log("value is", value);
        if (value == 1) this.form.action = "<";
        else this.form.action = ">";
      }
    },
    "form.sensor"(sensor) {
      // console.log("sensoooooooooooor", this.form.sensor);
      if (sensor == "water") {
        this.form.action = ">";
        this.form.value = 0;
      } else if (
        // this.device.data.sensor_type != 6 &&
        this.device.data.sensor_type != 7 &&
        sensor != "water" &&
        sensor != "hall" &&
        this.config == false &&
        !this.editRuleSensor
      ) {
        this.form.action = null;
        this.form.value = null;
      }
    },
    "form.repeat_settings_type"() {
      this.resetNewRepeatSettings();
    },
    device: {
      handler() {
        // console.log("rules", this.rules, this.device, this.exceeds);
        if (this.device.settings.sensor_type == 21) {
          this.form.sensor = "isVibrating";
        }
      },
      deep: true,
    },
    showNewScheduleForm(show) {
      if (show) {
        this.$nextTick(() => {
          // scroll to form
          this.$refs.scheduleSettingForm.scrollIntoView({ behavior: "smooth" });
        });
      }
    },
  },
  created() {
    this.setLang();
    this.device;
    this.resetNewRepeatSettings();
  },
  mounted() {
    this.timeToDisconnect = this.ttl;
    this.resetNewRepeatSettings();
    // console.log("sensors", this.sensors);
  },
  methods: {
    saveRepFromDialog(value) {
      this.form.repeats = this.timeToNum(value);
    },
    saveCounterRepFromDialog(value) {
      this.form.counter_repeats = this.timeToNum(value);
    },
    timeToNum(time) {
      time = time.split(":");
      let seconds = Math.ceil((100 / 60) * time[1]);
      seconds = String(seconds).padStart(2, "0");
      return parseFloat(time[0] + "." + seconds);
    },
    numToTime(number) {
      let time = parseFloat(number);
      if (time == 0) return "00:00";
      time = time.toFixed(2).split(".");
      time[0] = time[0].padStart(2, "0");
      time[1] = parseInt(time[1]);
      time[1] = String(parseInt((time[1] / 100) * 60)).padStart(2, "0");
      return time.join(":");
    },
    largetimeToNum(time) {
      let totalMinutes = time.split(":").map((n) => parseInt(n));
      totalMinutes = totalMinutes[0] * 60 + totalMinutes[1];
      return totalMinutes;
    },
    numToLargetime(totalMinutes) {
      let time = parseInt(totalMinutes);
      const hours = time >= 60 ? Math.floor(time / 60) : 0;
      const minutes = totalMinutes - hours * 60;
      const result = [
        String(hours).padStart(2, "0"),
        String(minutes).padStart(2, "0"),
      ].join(":");
      return result;
    },
    editDisconnect() {
      this.editDisconnectTime = true;
    },
    editRepeats() {
      this.editRepeatsTime = true;
    },
    editCounterRepeats() {
      this.editCounterRepeatsTime = true;
    },
    openPanel() {
      this.openAccordion = [0];
    },
    changeRepeat(add = true, run = true) {
      let counter = 0;
      if (run) {
        clearInterval(this.touching);
        this.touching = false;
        if (add) {
          this.touching = setInterval(() => {
            counter++;
            this.plusMinRepeat(
              this.form.repeats,
              this.getMultiplyByCounter(counter)
            );
          }, 150);
        } else {
          this.touching = setInterval(() => {
            counter++;
            this.minusMinRepeat(
              this.form.repeats,
              this.getMultiplyByCounter(counter)
            );
          }, 150);
        }
      } else {
        clearInterval(this.touching);
        this.touching = false;
      }
    },
    changeRepeatSettings(add = true, run = true) {
      let counter = 0;
      if (run) {
        clearInterval(this.touching);
        this.touching = false;
        if (add) {
          this.touching = setInterval(() => {
            counter++;
            this.plusRepeatSettings(
              this.newRepeatSettings.repeat_after,
              this.getMultiplyByCounter(counter)
            );
          }, 150);
        } else {
          this.touching = setInterval(() => {
            counter++;
            this.minusRepeatSettings(
              this.newRepeatSettings.repeat_after,
              this.getMultiplyByCounter(counter)
            );
          }, 150);
        }
      } else {
        clearInterval(this.touching);
        this.touching = false;
      }
    },
    changeDisconnect(add = true, run = true) {
      let counter = 0;
      if (run) {
        clearInterval(this.touching);
        this.touching = false;
        if (add) {
          this.touching = setInterval(() => {
            counter++;
            this.plusMinDisconnect(
              this.timeToDisconnect,
              this.getMultiplyByCounter(counter)
            );
          }, 150);
        } else {
          this.touching = setInterval(() => {
            counter++;
            this.minusMinDisconnect(
              this.timeToDisconnect,
              this.getMultiplyByCounter(counter)
            );
          }, 150);
        }
      } else {
        clearInterval(this.touching);
        this.touching = false;
      }
    },
    changeCounter(add = true, run = true) {
      let counter = 0;
      if (run) {
        clearInterval(this.touching);
        this.touching = false;
        if (add) {
          this.touching = setInterval(() => {
            counter++;
            this.plusMinCounter(
              this.form.counter_repeats,
              this.getMultiplyByCounter(counter)
            );
          }, 150);
        } else {
          this.touching = setInterval(() => {
            counter++;
            this.minusMinCounter(
              this.form.counter_repeats,
              this.getMultiplyByCounter(counter)
            );
          }, 150);
        }
      } else {
        clearInterval(this.touching);
        this.touching = false;
      }
    },
    changeScheduleStartAt(add = true, run = true) {
      let counter = 0;
      if (run) {
        clearInterval(this.touching);
        this.touching = false;
        if (add) {
          this.touching = setInterval(() => {
            counter++;
            this.plusScheduleStartAt(
              this.newScheduleSettings.start_at,
              this.getMultiplyByCounter(counter)
            );
          }, 150);
        } else {
          this.touching = setInterval(() => {
            counter++;
            this.minusScheduleStartAt(
              this.newScheduleSettings.start_at,
              this.getMultiplyByCounter(counter)
            );
          }, 150);
        }
      } else {
        clearInterval(this.touching);
        this.touching = false;
      }
    },
    changeScheduleEndAt(add = true, run = true) {
      let counter = 0;
      if (run) {
        clearInterval(this.touching);
        this.touching = false;
        if (add) {
          this.touching = setInterval(() => {
            counter++;
            this.plusScheduleEndAt(
              this.newScheduleSettings.end_at,
              this.getMultiplyByCounter(counter)
            );
          }, 150);
        } else {
          this.touching = setInterval(() => {
            counter++;
            this.minusScheduleEndAt(
              this.newScheduleSettings.end_at,
              this.getMultiplyByCounter(counter)
            );
          }, 150);
        }
      } else {
        clearInterval(this.touching);
        this.touching = false;
      }
    },
    plusMinRepeat(time, multiply = 1) {
      time = parseFloat(time);
      if (time < 1000) {
        time += this.cycle * multiply;
        this.form.repeats = time.toFixed(2);
      }
    },
    plusScheduleStartAt(time, multiply = 1) {
      time = parseInt(time);
      time += multiply;
      if (time > 1439) time = 1439;
      if (time >= this.newScheduleSettings.end_at)
        time = this.newScheduleSettings.end_at - 1;
      this.newScheduleSettings.start_at = parseInt(time);
    },
    plusScheduleEndAt(time, multiply = 1) {
      time = parseInt(time);
      time += multiply;
      if (time > 1439) time = 1439;
      this.newScheduleSettings.end_at = parseInt(time);
    },
    plusRepeatSettings(time, multiply = 1) {
      time = parseInt(time);
      if (time < 2880) {
        time += multiply;
        this.newRepeatSettings.repeat_after = parseInt(time);
      }
    },
    plusMinCounter(time, multiply = 1) {
      time = parseFloat(time);
      if (time < 1000) {
        time += this.cycle * multiply;
        this.form.counter_repeats = time.toFixed(2);
      }
    },
    plusMinDisconnect(time, multiply = 1) {
      time = parseFloat(time);
      if (time < 1000) {
        time += 1 * multiply;
        this.timeToDisconnect = parseInt(time);
      }
    },
    minusMinDisconnect(time, multiply = 1) {
      time = parseFloat(time);
      if (time > 0) {
        time -= 1 * multiply;
        if (time >= 2) {
          this.timeToDisconnect = parseInt(time);
        }
      }
    },
    minusMinRepeat(time, multiply = 1) {
      time = parseFloat(time);
      if (time > 0) {
        time -= this.cycle * multiply;
        if (time < 0) time = 0;
        this.form.repeats = time.toFixed(2);
      }
    },
    minusScheduleStartAt(time, multiply = 1) {
      time = parseInt(time);
      if (time > 0) {
        time -= multiply;
        if (time < 0) time = 0;
        this.newScheduleSettings.start_at = parseInt(time);
      }
    },
    minusScheduleEndAt(time, multiply = 1) {
      time = parseInt(time);
      if (time > 0) {
        time -= multiply;
        if (time < 0) time = 0;

        if (time <= this.newScheduleSettings.start_at)
          time = this.newScheduleSettings.start_at + 1;
        this.newScheduleSettings.end_at = parseInt(time);
      }
    },
    minusRepeatSettings(time, multiply = 1) {
      time = parseInt(time);
      if (time > 0) {
        time -= multiply;
        if (time < this.minNewRepeatTime) {
          time = this.minNewRepeatTime;
        }
        this.newRepeatSettings.repeat_after = parseInt(time);
      }
    },
    minusMinCounter(time, multiply = 1) {
      time = parseFloat(time);
      if (time > 0) {
        time -= this.cycle * multiply;
        if (time < 0) time = 0;
        this.form.counter_repeats = time.toFixed(2);
      }
    },
    getMultiplyByCounter(counter) {
      switch (true) {
        case counter > 150:
          return 80;
        case counter > 100:
          return 40;
        case counter > 80:
          return 20;
        case counter > 60:
          return 10;
        case counter > 40:
          return 5;
        case counter > 30:
          return 4;
        case counter > 20:
          return 3;
        case counter > 10:
          return 2;
        default:
          return 1;
      }
    },
    setLang() {
      let lang = Lang.get();
      if (lang == "en") {
        this.content = {
          select_new: "Create a Notification Rule",
          select_edit: "Edit a Notification Rule",
          correctState: "Normal status",
          add: "Create Rule",
          edit: "Edit",
          header: "Edit notification rules",
          threshold: "Threshold",
          top: "Top Threshold",
          bottom: "Bottom Threshold",
          open: "Opened",
          close: "Closed",
          lightOn: "Light On",
          lightOff: "Light Off",
          vibrateOn: "Vibrating",
          vibrateOff: "Not Vibrating",
          decimal: "The threshold must be a whole number",
          cantChange: "Can't change those settings for this device",
        };
      } else if (lang == "he") {
        this.content = {
          select_new: "יצירת חוק להתראה",
          select_edit: "עריכת חוק להתראה",
          correctState: "מצב תקין",
          add: "יצירת הגדרה",
          edit: "עריכה",
          header: "הגדרות התראה",
          threshold: "סף",
          top: "סף עליון",
          bottom: "סף תחתון",
          open: "פתוח",
          close: "סגור",
          lightOn: "אור דולק",
          lightOff: "אור כבוי",
          vibrateOn: "רעידות",
          vibrateOff: "ללא רעידות",
          decimal: "הסף חייב להיות מספר שלם",
          cantChange: "לחיישן זה לא ניתן לשנות הגדרות אלו",
        };
      }
      return lang;
    },
    getDayName(day) {
      let dayName;
      switch (day) {
        case 1:
          dayName = "sunday";
          break;
        case 2:
          dayName = "monday";
          break;
        case 3:
          dayName = "tuesday";
          break;
        case 4:
          dayName = "wednesday";
          break;
        case 5:
          dayName = "thursday";
          break;
        case 6:
          dayName = "friday";
          break;
        case 7:
          dayName = "saturday";
          break;
      }
      return this.$t(`fullWeekDays.${dayName}`);
    },
    addRule() {
      this.close();
      this.dialog = true;
      let repeatTime = this.notificationsDefaultTime;
      if ([10, 11].includes(parseInt(this.device.data.sensor_type))) {
        repeatTime = 0;
      }
      if (this.sensors && this.sensors.length == 1) {
        this.form.sensor = this.sensors[0].value;
      }
      this.form.repeats = repeatTime;
      this.form.counter_repeats = repeatTime;
    },
    deleteRule(rule) {
      if (this.deleteRuleSensor) {
        axios
          .delete(
            `/devices/${this.$route.params.slug}/notifications/rules/${this.deleteRuleSensor}/delete`
          )
          .then((res) => {
            this.$store.dispatch("devices/setDevice", res.data.data);
            this.$store.dispatch("general/setAlert", {
              type: "success",
              msg: "deleteRule",
            });
            this.dialog = false;
          })
          .catch(() => {
            // console.log("ERROR: ", err);
            this.$store.dispatch("general/setAlert", {
              type: "failed",
              msg: "oops",
            });
          });

        this.deleteRuleSensor = null;
      } else {
        this.deleteRuleSensor = rule.id;
      }
    },
    submitEdit() {
      // this.form.repeat_settings = this.currentRepeatSettings;
      const form = { ...this.form };
      form.schedules = form.schedules.map((schedule) => {
        if (`${schedule.slug}`.includes("new-")) delete schedule.slug;
        // console.log("schedule", schedule);
        return schedule;
      });
      form.repeat_settings = form.repeat_settings.filter((repeat) => {
        return repeat.recurring == this.form.repeat_settings_type;
      });
      axios
        .post(
          `/devices/${this.$route.params.slug}/notifications/rules/${this.editRuleSensor}/edit`,
          form
        )
        .then((res) => {
          const device = res.data.data;
          this.$store.dispatch("devices/setDevice", device);
          this.$store.dispatch("general/setAlert", {
            type: "success",
            msg: "editRule",
          });
          this.device;
          this.close();
        })
        .catch(() => {
          // console.log("ERROR: ", err);
          this.$store.dispatch("general/setAlert", {
            type: "failed",
            msg: "oops",
          });
        });
    },
    undoChanges() {
      this.form = JSON.parse(this.formClone);
    },
    editRule(rule) {
      // console.log("editRule");
      this.editRuleSensor = rule.id;
      this.form.sensor = rule.sensor;
      this.form.action = rule.action;
      this.form.value = rule.value;
      this.form.repeats = rule.repeats;
      this.form.counter_repeats = rule.counter_repeats;
      this.form.notifications.email = rule.notifications.email;
      this.form.notifications.sms = rule.notifications.sms;
      this.form.notifications.push = rule.notifications.push;
      this.form.notifications.whatsapp = rule.notifications.whatsapp;
      this.form.schedules = rule.schedules;
      this.form.repeat_settings = rule.repeat_settings;
      if (this.form.repeat_settings.length) {
        this.form.repeat_settings_type = this.form.repeat_settings[0].recurring;
      }
      // console.log("form", this.form);
    },
    configRule(rule) {
      // console.log("rule", rule);
      this.resetForm();
      this.config = true;
      this.editRuleSensor = rule.id;
      this.form.sensor = rule.sensor;
      if (
        rule.sensor == "hall" ||
        rule.sensor == "isVibrating" ||
        rule.sensor == "drycontact"
      ) {
        this.form.value = parseInt(rule.value);
      } else {
        this.form.value = rule.value;
      }
      this.form.action = rule.action;
      this.form.repeats = rule.repeats;
      this.form.schedules = rule.schedules;
      this.form.counter_repeats = rule.counter_repeats;
      this.form.notifications.email = rule.notifications.email;
      this.form.notifications.sms = rule.notifications.sms;
      this.form.notifications.push = rule.notifications.push;
      this.form.notifications.whatsapp = rule.notifications.whatsapp;
      this.form.repeat_settings = rule.repeat_settings.sort(
        (a, b) => a.repeat_after - b.repeat_after
      );
      if (rule.repeat_settings && rule.repeat_settings.length) {
        this.showNotificationRepeatsSettings = true;
        this.form.repeat_settings_type = rule.repeat_settings[0].recurring;
        this.useNotificationRepeatsSettings = true;
      }
      if (rule.schedules.length > 0) {
        this.showNotificationScheduleSettings = true;
        this.useNotificationScheduleSettings = true;
      }
      this.formClone = JSON.stringify(this.form);

      this.dialog = true;
    },
    close() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      this.dialog = false;
      this.editRuleSensor = null;
      this.editRepeatsTime = false;
      this.editCounterRepeatsTime = false;
      this.config = false;
      this.resetForm();
    },
    resetForm() {
      this.form.action = null;
      this.form.value = null;
      this.form.sensor = null;
      this.form.notifications.email = 1;
      this.form.notifications.sms = 1;
      this.form.notifications.push = 1;
      this.form.repeats = 0;
      this.form.counter_repeats = 0;
      this.form.schedules = [];
      this.form.repeat_settings = [];
      this.customMsg.forText = false;
      this.customMsg.forCounterText = false;
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.form.repeat_settings = this.currentRepeatSettings;
        // console.log(this.form);
        const form = { ...this.form };
        form.schedules = form.schedules.map((schedule) => {
          if (`${schedule.slug}`.includes("new-")) delete schedule.slug;
          return schedule;
        });
        axios
          .post(
            `/devices/${this.$route.params.slug}/notifications/rules/new`,
            form
          )
          .then((res) => {
            const device = { ...this.device };
            for (const param in res.data.data) {
              device[param] = res.data.data[param];
            }
            this.$store.dispatch("devices/setDevice", device);
            this.$store.dispatch("general/setAlert", {
              type: "success",
              msg: "addRule",
            });
            this.device;
            this.close();
          })
          .catch(() => {
            this.$store.dispatch("general/setAlert", {
              type: "failed",
              msg: "oops",
            });
          });
      }
    },
    disconnectChange() {
      axios
        .post(`/devices/${this.$route.params.slug}/notifications/disconnect`, {
          ttl: this.timeToDisconnect,
        })
        .then((res) => {
          const device = res.data.data;
          this.$store.dispatch("devices/setDevice", device);
          this.$store.dispatch("general/setAlert", {
            type: "success",
            msg: "addRule",
          });
          this.openAccordion = [];
        })
        .catch(() => {
          this.$store.dispatch("general/setAlert", {
            type: "failed",
            msg: "min2",
          });
        });
      return this.timeToDisconnect;
    },
    showNewRepeatSettings() {
      this.resetNewRepeatSettings();
      this.showNewRepeatForm = true;
    },
    resetNewRepeatSettings() {
      this.newRepeatSettings = {
        repeat_after: this.minNewRepeatTime + 4,
        channels: {
          push: 1,
          email: 1,
          sms: 1,
        },
      };
    },
    removeRepeat(i) {
      let repeats = [...this.form.repeat_settings];
      delete repeats[i];
      this.form.repeat_settings = repeats.filter((r) => r);
    },
    editSchedule(i) {
      let schedules = [...this.form.schedules];
      const schedule = schedules[i];
      // console.log("editSchedule", { ...schedule });
      this.newScheduleSettings = { index: i, ...schedule };
      this.showNotificationScheduleSettings = true;
      this.useNotificationScheduleSettings = true;
      this.showNewScheduleForm = true;
      this.$nextTick(() => {
        // scroll to form
        this.$refs.scheduleSettingForm.scrollIntoView({ behavior: "smooth" });
      });
      // delete schedules[i];
      // this.form.schedules = schedules.filter((r) => r);
    },
    removeSchedule(i) {
      let schedules = [...this.form.schedules];
      delete schedules[i];
      this.form.schedules = schedules.filter((r) => r);
    },
    closeNewScheduleForm() {
      if (this.newScheduleSettings.slug) {
        // this.form.schedules.push(this.newScheduleSettings);
      }
      this.newScheduleSettings = {
        days: [1, 2, 3, 4, 5, 6, 7],
        start_at: 0,
        end_at: 1439,
      };
      this.showNewScheduleForm = false;
    },
    addNewRepeatSettings() {
      this.newRepeatSettings.recurring = this.form.repeat_settings_type;
      this.form.repeat_settings.push(this.newRepeatSettings);
      this.showNewRepeatForm = false;
      this.resetNewRepeatSettings();
    },
    SaveScheduleSettings() {
      // console.log("SaveScheduleSettings", this.newScheduleSettings);
      if (this.newScheduleSettings.slug) {
        this.form.schedules[this.newScheduleSettings.index] = {
          days: this.newScheduleSettings.days.sort((a, b) => a - b),
          start_at: this.newScheduleSettings.start_at,
          end_at: this.newScheduleSettings.end_at,
          slug: this.newScheduleSettings.slug,
        };
      } else {
        this.newScheduleSettings.slug = "new-" + +new Date();
        this.form.schedules.push(this.newScheduleSettings);
      }
      this.showNewScheduleForm = false;
      this.newScheduleSettings = {
        days: [1, 2, 3, 4, 5, 6, 7],
        start_at: 0,
        end_at: 1439,
      };
      // console.log("this.form.schedules", this.form.schedules);
    },
  },
};
</script>
<style lang="scss" scoped>
small {
  white-space: normal;
}
.disconnectTime,
.counterRepeatTime,
.repeatTime {
  width: 100px;
}

.editRules {
  border-radius: 10px;
  // background-color: rgba(255, 255, 255, 1);
  background-color: rgba(25, 118, 210, 0.1);
  .editBtn {
    width: max-content;
    border-radius: unset;
    .mx-3,
    .v-icon {
      color: #235db4;
    }
  }
}

.addRuleBtn {
  border: 1px solid;
  border-radius: 5px;
}

.rule {
  border-radius: 10px;
  background: rgb(255, 255, 255);
  margin-top: 5px;
}

.advanced {
  // margin-inline-start: 35px;
  font-size: 10pt;
  color: #235db4;
  // cursor: pointer;
  span {
    text-decoration: underline;
  }
}
.disconnectRule {
  margin-top: -6px;
}

.disconnectLabel {
  font-size: 11pt;
  text-align: center;
  padding: 5px;
  text-decoration: underline;
}

// .advancedOpts {
//   // display: flex;
//   // flex-direction: row;
//   justify-content: center;
//   // margin-top: 20px;
//   .form {
//     display: flex;
//     flex-direction: column;
//     justify-content: center;
//     color: darkslategrey;
//     // .disableForDevice {
//     //   margin: 0 auto;
//     //   text-align: center;
//     // }

//     span {
//       text-decoration: underline;
//       font-size: 12pt;
//     }
//     .shrink {
//       text-align: start;
//     }
//     .formSwitchs {
//       display: flex;
//       flex-direction: row;
//       justify-content: space-between;
//       margin-bottom: 8px;
//       align-items: center;
//       div {
//         display: flex;
//         flex-direction: row;
//         justify-content: space-around;
//         align-items: center;
//         .switchLabel {
//           padding-inline-end: 10px;
//         }
//       }
//     }
//     h1 {
//       margin-top: 20px;
//       font-size: 10pt;
//       color: red;
//       font-weight: 600;
//       text-align: center;
//     }
//   }
// }
.repeats,
.counters {
  // margin: 10px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  max-width: 230px;
  div {
    font-size: 14pt;
  }
  small {
    text-decoration: none;
    font-size: 10pt;
  }
}
.very-small {
  white-space: normal;
  text-align: center;
  width: 100%;
  font-size: 80%;
}
.notification-settings {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
  height: 100%;
  justify-content: space-evenly;
  .notification-settings-card {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    // min-width: 250px;
    max-width: 400px;
    // max-width: 50%;
    padding: 24px 8px 0px 8px;
    white-space: nowrap;
    .notification-settings-card-title {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .notification-settings-card-title-block {
        min-width: 40px;
      }
      // position: relative;
      // width: 100%;
      // margin: 0 auto;
      // text-align: center;
      // small {
      //   position: absolute;
      //   right: 8px;
      //   transform: translateY(-50%);
      //   top: 50%;
      // }
      // .v-icon {
      //   position: absolute;
      //   left: 8px;
      //   transform: translateY(-50%);
      //   top: 50%;
      // }
    }
    .setting-block {
      flex: 0;
      border-radius: 10px;
      box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
        0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
      width: 100%;
      padding: 8px 16px;
      background-color: #fff;
    }
    .schedule-block {
      line-height: 1.2;
      padding: 12px 16px;
    }
    .pop-design {
      box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
        0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
      background-color: #fff;
    }
  }
}

.repeat-inner-text {
  small {
    min-width: 50px;
    .text-end {
      text-align: end;
    }
    .text-start {
      text-align: start;
    }
  }
}
.no-stretch {
  flex: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media screen and (min-width: 950px) and (min-height: 800px) {
  .rule-settings-card-text {
    min-height: 400px;
  }
}
@media screen and (max-width: 950px) {
  .expandable-card {
    cursor: pointer;
  }
}
</style>
<style lang="scss">
.short-checkboxes {
  label {
    margin-right: 0px !important;
    margin-left: 0px !important;
    // margin-inline-end: 4px;
    padding-inline-end: 8px;
  }
}
.notification-settings-card-title-block {
  .v-input--checkbox {
    margin: 0px;
    padding: 0px;
    .v-input--selection-controls__input {
      margin: 0;
    }
  }
}
</style>
